/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ErrorData, ErrorPayload } from '@types';

export type BotTryConfig = {
  allowPickupWhenBotInteraction: boolean;
  showBotsInbox: boolean;
};

export type ConsoleGeneralSettingsState = {
  loading: 'idle' | 'success' | 'pending';

  generalProperties: {
    preferences: {
      agentConsoleConfig: {
        allowPickupWhenBotInteraction: boolean;
      };
    };
  };
  error?: ErrorData | ErrorPayload;
};

const initialState: ConsoleGeneralSettingsState = {
  loading: 'idle',

  error: undefined,
  generalProperties: {
    preferences: {
      agentConsoleConfig: {
        allowPickupWhenBotInteraction: false,
      },
    },
  },
};

export const consoleGeneralSettingsSlice = createSlice({
  name: 'consoleGeneralSettings',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateBotTrayConfig(_state, _action: PayloadAction<BotTryConfig>) {},
    updateBotTrayConfigFailure(_state, _action: PayloadAction<ErrorData>) {},
  },
});

export default consoleGeneralSettingsSlice.reducer;

export const { updateBotTrayConfig, updateBotTrayConfigFailure } =
  consoleGeneralSettingsSlice.actions;
